// Describes a form or email that shows a file, or a signup that gives it
// away (from POST /api/files/usages): what it is, and where to edit it.
const SENT = ["sent", "sending"];

export function describeUsage(u) {
  switch (u.kind) {
    case "form":
      return { text: `Form "${u.name}" in signup "${u.parent_name}"`, href: `/signups/${u.parent_id}/edit/form/${u.id}` };
    case "signup_email":
      return { text: `Email "${u.name}" in signup "${u.parent_name}"`, href: `/signups/${u.parent_id}/edit/mail/${u.id}` };
    case "broadcast_email":
      return {
        text: `Email "${u.name}" in broadcast "${u.parent_name}"`,
        href: `/broadcasts/${u.parent_id}/email/${u.id}`,
        sent: SENT.includes(u.status),
      };
    case "sequence_email":
      return { text: `Email "${u.name}" in sequence "${u.parent_name}"`, href: `/sequences/${u.parent_id}/steps/${u.id}/email` };
    case "giveaway":
      return { text: `Giveaway in signup "${u.parent_name}"`, href: `/signups/${u.parent_id}/edit?section=incentives`, giveaway: true };
    case "email_template":
      return { text: `Email template "${u.name}"`, href: `/templates/${u.id}` };
    default:
      return { text: u.name || u.kind, href: null };
  }
}

// groupUsages groups usages by file name, keeping the server's order.
export function groupUsages(usages) {
  const groups = [];
  (Array.isArray(usages) ? usages : []).forEach((u) => {
    let g = groups.find((x) => x.fileName === u.file_name);
    if (!g) {
      g = { fileName: u.file_name, usages: [] };
      groups.push(g);
    }
    g.usages.push(u);
  });
  return groups;
}
